import React from 'react';

export const SectionLink = ({ name }: { name: string }) => {
  const splitName = name.split('#');
  const sectionId = splitName.length > 1 ? splitName[1] : '';

  //NOTE: if page hasn't been loaded yet it will have problem scrolling it using hash
  React.useEffect(() => {
    if (!sectionId) {
      return;
    }
    const hash = window.location.hash;
    if (!hash) {
      return;
    }

    const replacedHash = hash.replace('#', '');
    if (replacedHash !== sectionId) {
      return;
    }

    const section = document.getElementById(sectionId);
    if (!section) {
      return;
    }

    const handler = setTimeout(() => {
      section.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }, 160);

    return () => {
      clearTimeout(handler);
    };
  }, [sectionId]);

  return <div id={sectionId} className="-scroll-mt-[350px]"></div>;
};
